import { Constants } from '../constants/constants';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import Swal from 'sweetalert2/dist/sweetalert2.all.js'; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from '../utils/utils';

@Injectable({
  providedIn: 'root'
})
export class MotivoService {

  
  constructor(private http: HttpClient, private utils:Utils) { }

  
  public getMotivo(idMotivo): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_MOTIVO + '/' + idMotivo;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: 'Error Motivo',
            text: 'Error Cargando Motivo.',
            type: 'error'
          });
        }
        
        return throwError(err);
      })
    );
  }

  public postMotivo(params): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_MOTIVO;
    return this.http.post<any>(url, params)
      .pipe(
        catchError(err => {
          if (err.status === 401) {
            this.utils.cerrarSesion();
          }
          else if (err.status === 409){
            Swal.fire({
              title: 'Error Motivo',
              text: 'Este Codigo Ya Existe, veirifique la información.',
              type: 'error',
              confirmButtonColor: '#127570'
            });
          } 
           else {
            Swal.fire({
              title: 'Error Motivo',
              text: 'Verifique la informacion ingresada.',
              type: 'error',
              confirmButtonColor: '#127570'
            });
          }   
          
          return throwError(err);
        })
      );
  }

  public putMotivo(idMotivo, params): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_MOTIVO + '/' + idMotivo;
    return this.http.put<any>(url, params).pipe(
      catchError(err => {
        Swal.fire({
          title: 'Error Motivo',
          text: 'Error actualizando información del motivo.',
          type: 'error'
        });
        return throwError(err);
      })
    );
  }



  public deleteMotivo(idMotivo, usuario): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_MOTIVO + '/' + idMotivo + '/' + usuario;
    return this.http.delete<any>(url).pipe(
      catchError(err => {
        Swal.fire({
          title: 'Error Motivo',
          text: 'Error eliminado información del motivo.',
          type: 'error'
        });
        return throwError(err);
      })
    );
  }



}
